<template>
    <div>
        <div style="margin: 3px 0px 3px 0px;padding: 3px;background: white">
            <el-row style="display: flex">
                <el-tooltip class="item" effect="dark" content="修改密码" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-edit" circle @click="changepwd" type="primary"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="刷新" placement="bottom" style="margin-left: 8px">
                    <el-button icon="el-icon-refresh-right" circle @click="reflash" type="success"></el-button>
                </el-tooltip>
            </el-row>
        </div>
        <el-form ref="from" :model="dataSet" style="background: white;padding:15px">
            <el-form-item label="区域">
                <span>{{expArea(dataSet.area)}}</span>
            </el-form-item>
            <el-form-item label="代理商级别">
                <span>{{exp(dataSet.rolelv)}}</span>
            </el-form-item>
            <el-form-item label="销售进度（季度）" v-if="dataSet.rolelv != 3">
                <el-progress :percentage="quarterpercentage" color="blue"></el-progress>
                <span>{{dataSet.quartertarget}}</span>
            </el-form-item>
            <el-form-item label="销售进度（年度）" v-if="dataSet.rolelv != 3">
                <el-progress :percentage="yearpercentage" color="blue"></el-progress>
                <span>{{dataSet.yeartarget}}</span>
            </el-form-item>
            <el-form-item label="保证金">
                <span>{{parseFloat(dataSet.deposit)}}</span>
            </el-form-item>
            <el-form-item label="积分" v-if="dataSet.rolelv != 3">
                <span>{{parseFloat(dataSet.points)}}</span>
            </el-form-item>
            <el-form-item label="子经销商数量">
                <span style="color:blue" @click="showSon">{{dataSet.childsnum}}</span>
            </el-form-item>
        </el-form>
        <el-dialog :visible.sync="isShowSon" width="80%" :close-on-click-modal="false">
            <el-table
                    :data="dataSet.childs"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:20px"
            >
                <el-table-column show-overflow-tooltip prop="dealername" label="经销商名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="rolelv" label="级别">
                    <template scope="scope">
                        <span>{{exprolelv(scope.row.rolelv)}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="area" label="区域">
                    <template scope="scope">
                        <span>{{expArea(scope.row.area)}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="signtime" label="签约时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="branchnum" label="下属市代数量" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="contractfile" label="合同信息">
                    <template scope="scope">
                        <a style="color: blue" @click="checkFile(scope.row.contractfile)" v-if="scope.row.contractfile != ''">查看</a>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="dealercode" label="经销商编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="points" label="积分" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="状态">
                    <template scope="scope">
                        <span>{{expstatus(scope.row.status)}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="quartertarget" label="季度目标" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="yeartarget" label="年度目标" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="deposit" label="保证金" align="right"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowSon = false">关闭</el-button>
			</span>
        </el-dialog>
        <el-dialog :visible.sync="isShowChangePwd" width="40%" :close-on-click-modal="false">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="原密码" prop="old_pwd">
                    <el-input type="password" v-model="ruleForm.old_pwd"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="new_pwd">
                    <el-input type="password" v-model="ruleForm.new_pwd" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="check_pwd">
                    <el-input type="password" v-model="ruleForm.check_pwd" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                    <el-button type="primary" @click="submitForm()">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import axios from 'axios';

    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.new_pwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                dataSet:{},
                isShowSon: false,
                isShowChangePwd: false,
                ruleForm: {
                    old_pwd: '',
                    new_pwd: '',
                    check_pwd: ''
                },
                rules: {
                    check_pwd: [
                        { validator: validatePass, trigger: 'blur' }
                    ]
                },
                quarterpercentage: 0,
                yearpercentage: 0
            };
        },
        mounted: function () {
            let that = this
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.token = that.userData.token
            that.user = that.userData.username
            that.usercode = that.userData.Login_Code
            that.useriid = that.userData.iid
            that.getView()
        },
        methods: {
            reflash() {
                let that = this
                that.getView()
            },
            changepwd() {
                let that = this
                that.isShowChangePwd = true
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            submitForm() {
                let that = this
                let datetime = Common.methods.getDatetime
                let parm = {
                    iid: that.useriid,
                    old_pwd: that.ruleForm.old_pwd,
                    new_pwd: that.ruleForm.new_pwd,
                    modifypersoncode: that.usercode,
                    modifypersonname: that.user,
                    modifytime: datetime
                }
                that.$http.urlpost('/SysDealerUsers/ChangePwd', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.isShowChangePwd = false
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            getView() {
                let that = this
                let parm = {
                    iid: that.useriid,
                };
                that.$http.urlpost('/SysDealerUsers/UserCenter', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        if(that.dataSet.quartertarget != ''){
                            let arr = that.dataSet.quartertarget.split('/')
                            that.quarterpercentage = (arr[0]/arr[1] * 100).toFixed(2)
                        }
                        if(that.dataSet.yeartarget != ''){
                            let arr = that.dataSet.yeartarget.split('/')
                            that.yearpercentage = (arr[0]/arr[1] * 100).toFixed(2)
                        }
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            showSon() {
                let that = this
                that.isShowSon = true
            },
            exprolelv(value){
                if(value == 0){
                    return "普通"
                } else if(value == 1) {
                    return "市代"
                } else if(value == 2) {
                    return "省代"
                }
            },
            expstatus(value) {
                if(value == 0){
                    return "待审核"
                } else if(value == 1) {
                    return "正常"
                } else if(value == 2) {
                    return "禁用"
                }
            },
            //0普通1市代2省代
            exp(value) {
                if(value == 0){
                    return '普通'
                } else if (value == 1){
                    return '市代'
                } else if (value == 2){
                    return '省代'
                } else if (value == 3){
                    return 'B类'
                }
            },
            expArea(value){
                return Common.methods.getArea(value)
            },
            checkFile(value) {
                let that = this;
                window.open(Common.Url + 'uploads/' + value);
            },
        }
    };
</script>

<style scoped lang="less">
</style>
